import React from "react";
import styled from "styled-components";
import { lensProp, view } from "ramda";
import ImageFadeIn from "../common/BackgroundImage";
import WatermarkIcon from "../../../images/watermark.png";

const width = Math.min(600, window.screen.width);
const TOP_NINE_MARGIN = 20;
const MARGIN_BETWEEN_ITEM = 2;
const ITEM_SIZE = (width - TOP_NINE_MARGIN * (MARGIN_BETWEEN_ITEM * 2)) / 3;

export const HOLDER_WIDTH = ITEM_SIZE * 3 + MARGIN_BETWEEN_ITEM * 3;

const Grid = ({ items = [], updateSelectedGridBlock, selectedIndex }) => (
  <TopNineHolder>
    {items.slice(0, 9).map((item, index) => (
      <ItemContainer
        key={`editableItem-${index}`}
        isSelected={selectedIndex === index}
        onClick={() => updateSelectedGridBlock(index)}
        noBorder={index === 2 || index === 5 || index === 8}
      >
        {item.previewUri ? <TopNineItem backgroundImage={item.previewUri} /> : <EmptyBlock />}
      </ItemContainer>
    ))}
  </TopNineHolder>
);

const TopNineHolder = styled.div`
  background-color: white;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  height: ${HOLDER_WIDTH}px;
  width: ${HOLDER_WIDTH}px;
  margin: 0 ${TOP_NINE_MARGIN}px;
  margin-top: ${TOP_NINE_MARGIN}px;
  background-color: white;
  align-items: center;
  position: relative;
  justify-content: space-between;
  margin: auto;
`;

const ItemContainer = styled.div`
  width: ${ITEM_SIZE}px;
  height: ${ITEM_SIZE}px;
  margin-bottom: ${MARGIN_BETWEEN_ITEM}px;
  ${props => (!props.isSelected ? null : `border: 2px solid #448EFF; opacity: 0.3`)};
`;

const TopNineItem = styled(ImageFadeIn)`
  width: 100%;
  height: 100%;
`;

const EmptyBlock = styled.div`
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.07;
`;

export default Grid;
